<script lang="ts">

import type ChartPoint from './ChartPoint';
import { CHART_COLORS } from './ChartLayer';
import type { ChartColor } from './ChartLayer';

/**
 * VChartPoints — декларативный слой точек VChart. Сам ничего не рендерит, VChart разбирает его из слота.
 *
 * Точки разных слоёв, попавшие в одну экранную ячейку, VChart собирает в кластер.
 *
 * @example
 * <VChartPoints label="Заказы" color="yellow" :points="orders"/>
 * <VChartPoints label="Предзаказы" color="yellow" hollow :points="preorders"/>
 */
export default defineComponent({
  name: 'VChartPoints',

  props: {
    /** Подпись в легенде */
    label: {
      type:     String,
      required: true,
    },

    color: {
      type:      String as PropType<ChartColor>,
      required:  true,
      validator: (v: string) => (CHART_COLORS as readonly string[]).includes(v),
    },

    /** Кольцо без заливки — чтобы отличить слой того же цвета формой, а не оттенком */
    hollow: {
      type:    Boolean,
      default: false,
    },

    points: {
      type:     Array as PropType<ChartPoint[]>,
      required: true,
    },
  },

  render() {
    return null;
  },
});
</script>
